function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForwardAssignmentYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    id: "screenshot-024268f4-516e-8034-8006-0344565b40c5",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-024268f4-516e-8034-8006-0344565b40c5",
    width: 800,
    height: 800,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-024268f4-516e-8034-8006-0344565b40c6",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-024268f4-516e-8034-8006-0344565b40c6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-024268f4-516e-8034-8006-0344565b40c7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-024268f4-516e-8034-8006-0344565b40c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.667,6.667C7.035,6.667,7.333,6.368,7.333,6.000L7.333,2.000C7.333,1.632,7.035,1.333,6.667,1.333C6.298,1.333,6.000,1.632,6.000,2.000L6.000,6.000C6.000,6.368,6.298,6.667,6.667,6.667ZZ",
    className: "clr-i-solid--badged clr-i-solid-path-1--badged",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-024268f4-516e-8034-8006-0344565b40c8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-024268f4-516e-8034-8006-0344565b40c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.000,9.000C17.239,9.000,15.000,6.761,15.000,4.000L8.133,4.000L8.133,6.000C8.133,6.810,7.477,7.467,6.667,7.467C5.857,7.467,5.200,6.810,5.200,6.000L5.200,4.000L2.533,4.000C2.213,3.996,1.904,4.123,1.678,4.350C1.452,4.577,1.328,4.886,1.333,5.207L1.333,20.127C1.328,20.441,1.448,20.745,1.667,20.972C1.886,21.198,2.185,21.328,2.500,21.333L21.500,21.333C21.815,21.328,22.114,21.198,22.333,20.972C22.552,20.745,22.672,20.441,22.667,20.127L22.667,8.227C21.869,8.733,20.944,9.001,20.000,9.000ZZM6.667,17.333L5.333,17.333L5.333,16.000L6.667,16.000ZM6.667,14.000L5.333,14.000L5.333,12.667L6.667,12.667ZM6.667,10.667L5.333,10.667L5.333,9.333L6.667,9.333ZM10.667,17.333L9.333,17.333L9.333,16.000L10.667,16.000ZM10.667,14.000L9.333,14.000L9.333,12.667L10.667,12.667ZM10.667,10.667L9.333,10.667L9.333,9.333L10.667,9.333ZM14.667,17.333L13.333,17.333L13.333,16.000L14.667,16.000ZM14.667,14.000L13.333,14.000L13.333,12.667L14.667,12.667ZM14.667,10.667L13.333,10.667L13.333,9.333L14.667,9.333ZM18.667,17.333L17.333,17.333L17.333,16.000L18.667,16.000ZM18.667,14.000L17.333,14.000L17.333,12.667L18.667,12.667ZM18.667,10.667L17.333,10.667L17.333,9.333L18.667,9.333Z",
    className: "clr-i-solid--badged clr-i-solid-path-2--badged",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-024268f4-516e-8034-8006-0344565b40c9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-024268f4-516e-8034-8006-0344565b40c9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.999999999999886,
    cy: 4,
    rx: 3.3333333333333712,
    ry: 3.3333333333332575,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "clr-i-solid--badged clr-i-solid-path-3--badged clr-i-badge",
    style: {
      fill: "rgb(255, 193, 7)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-024268f4-516e-8034-8006-0344565b40ca"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-024268f4-516e-8034-8006-0344565b40ca"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForwardAssignmentYellow);
export default __webpack_public_path__ + "static/media/icon-forward-assignment-yellow.5b89053dac4a2dbc6c17bd3be9ae71c7.svg";
export { ForwardRef as ReactComponent };